export const black = "#000";
export const brown = "#00000080";
export const blue_color = "#0019ff";
export const bondiblue_color = "#00a2b4";
export const light_green = "#D9F6D9";
export const light_red_color = "#ffb09c";
